const userProfileModalTestIDs = {
  viewProfile: 'view-profile',

  optaviaId: 'profile-id',
  profileCoach: 'profile-coach',
  profileBusinessCoach: 'profile-business-coach',
  profileHighestRank: 'profile-highest-rank',
  profileCertified: 'profile-certified',
  profileRenewal: 'profile-renewal',

  profilePhone: 'profile-phone',
  profileEmail: 'profile-email',
  profileLocation: 'profile-location',

  reportPopoverScroll: 'report-popover-scroll',

  activationDate: 'activation-date',
  businessCoach: 'business-coach',
  orderHistoryNoItem: 'order-history-no-item',
  orderHistoryItem: 'order-history-item',
  orderHistoryDate: 'order-history-date',
  orderHistoryNumber: 'order-history-number',
  orderHistoryAmount: 'order-history-amount',
  premierMember: 'premier-member',
  lastOrderedOn: 'last-ordered-on',
  premierCancellationDate: 'premier-cancellation-date',
  joinedDate: 'joined-date',
  rewardsHistoryDate: 'rewards-history-date',
  rewardsHistoryStatus: 'rewards-history-status',
  rewardsHistoryBalance: 'rewards-history-balance',
  scheduledPremier: 'scheduled-premier',
  orderValue: 'order-value',
  scheduledDate: 'scheduled-date',
  cvValue: 'cv-value',
  rewardsBalance: 'rewards-balance',
  totalExpiringWellnessCreditsTitle: 'total-expiring-wellness-credits-title',
  totalExpiringWellnessCreditsValue: 'total-expiring-wellness-credits-value',
  expirationSubtitle: 'expiration-subtitle',
  amountSubtitle: 'amount-subtitle',
  expiringWellnessCreditsEmptyMessage:
    'expiring-wellness-credits-empty-message',
  expiringWellnessCreditsDate: 'expiring-wellness-credits-date',
  expiringWellnessCreditsValue: 'expiring-wellness-credits-value',
  expiringBeforeNextPremier: 'expiring-before-next-premier',
  nextScheduledPremier: 'next-scheduled-premier',
  totalWellnessCredits: 'total-wellness-credits',
};

export default userProfileModalTestIDs;
